import { render, staticRenderFns } from "./TheMenuLevel.vue?vue&type=template&id=65bb695e&"
import script from "./TheMenuLevel.vue?vue&type=script&lang=js&"
export * from "./TheMenuLevel.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuLevel.vue?vue&type=style&index=0&id=65bb695e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports